import filesize from 'filesize';
import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './FileSize.scss';
/**
 * @component FileSize
 * @since 1.0.0
 */
export function FileSize(props) {
    const { style, value } = Object.assign({ style: 'normal' }, props);
    const className = classNames('file-size', 'file-size--' + style, props.className);
    return React.createElement("span", { className: className }, filesize(value));
}
